__turbopack_context__.v({
  "canScrollDown": "scrollable-container-module-scss-module__vHfTlG__canScrollDown",
  "canScrollUp": "scrollable-container-module-scss-module__vHfTlG__canScrollUp",
  "scrollableContent": "scrollable-container-module-scss-module__vHfTlG__scrollableContent",
  "scrollableContentWrapper": "scrollable-container-module-scss-module__vHfTlG__scrollableContentWrapper",
});
